<template>
  <div
    v-if="
      unidatoObject != undefined &&
        unidatoObject != null &&
        parentPath &&
        visible &&
        unidatoObject.behavior.isVisible
    "
    class="unidata-editor"
    :class="ready"
    style="padding: 3px"
  >
    <div class="row mr-0">
      <div :class="templateConfiguration.label">
        <label
          v-if="showLabel == 1 || (showLabel == -1 && unidatoObject.behavior.showLabel)"
          v-tooltip="uniToolTipTranslation(unidatoObject.label, 'en-US')"
          class="label-unidato"
          >{{ uniTranslation(unidatoObject.label) }}</label
        >
      </div>
      <div
        v-if="
          showDropDown == 1 ||
            (showDropDown == -1 && dropdownUms && unidatoObject.behavior.showDropDown)
        "
        class="unidata-item-container"
        :class="templateConfiguration.um"
      >
        <el-select
          v-if="dropdownUms.length > 0"
          v-model="selectedUM"
          class="form-control select"
          :placeholder="uniTranslation('UM')"
          @change="changeSelectedUM"
        >
          <el-option
            v-for="item in dropdownUms"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div :class="unidataEditorColumns">
        <div class="row">
          <div
            v-if="showInput == 1 || (showInput == -1 && templateConfiguration.input)"
            class="unidata-item-container"
            :class="overrideInputClass ? overrideInputClass : templateConfiguration.input"
          >
            <!-- || (showInput == -1 && unidatoObject.behavior.showInput) -->
            <VueAutonumeric
              v-if="unidatoObject.behavior.showInput"
              v-model="inputVal"
              class="form-control auto-numeric"
              :disabled="disabilita"
              :options="{
                allowDecimalPadding: false,
                digitGroupSeparator: '',
                decimalCharacter: ',',
                decimalPlaces: inputDecimalNum,
                decimalCharacterAlternative: '.',
                currencySymbol: '\u00a0€',
                currencySymbolPlacement: 's',
                roundingMethod: 'D' /* 'U' */,
                emptyInputBehavior: cmpEmptyBehavior,
                symbolWhenUnfocused: '',
                selectOnFocus: 'false',
                currencySymbol: '',
                negativePositiveSignPlacement: 'p',
                minimumValue: outputMinNum,
                maximumValue: outputMaxNum
              }"
              @blur="onBlur"
            ></VueAutonumeric>
          </div>

          <div
            v-if="showOutput2 == 1 || (showOutput2 == -1 && templateConfiguration.output2)"
            class="unidata-item-container"
            :class="overrideOutput2Class ? overrideOutput2Class : templateConfiguration.output2"
          >
            <!-- || (showInput == -1 && unidatoObject.behavior.showOutputBT) -->
            <VueAutonumeric
              v-if="unidatoObject.behavior.showOutputBT"
              v-model="termicBalanceOutput"
              disabled="true"
              class="form-control auto-numeric"
              :options="{
                allowDecimalPadding: false,
                digitGroupSeparator: '',
                decimalCharacter: ',',
                decimalPlaces: balanceDecimalNum,
                decimalCharacterAlternative: '.',
                currencySymbol: '\u00a0€',
                currencySymbolPlacement: 's',
                roundingMethod: 'D' /* 'U' */,
                emptyInputBehavior: 'null',
                symbolWhenUnfocused: '',
                currencySymbol: '',
                negativePositiveSignPlacement: 'p',
                minimumValue: outputMinNum,
                maximumValue: outputMaxNum
              }"
            ></VueAutonumeric>
          </div>

          <div
            v-if="showOutput1 == 1 || (showOutput1 == -1 && templateConfiguration.output1)"
            class="unidata-item-container"
            :class="overrideOutput1Class ? overrideOutput1Class : templateConfiguration.output1"
          >
            <VueAutonumeric
              v-if="unidatoObject.behavior.showOutput"
              v-model="verifyValueOutput"
              disabled="true"
              class="form-control auto-numeric"
              :options="{
                allowDecimalPadding: false,
                digitGroupSeparator: '',
                decimalCharacter: ',',
                decimalPlaces: outputDecimalNum,
                decimalCharacterAlternative: '.',
                currencySymbol: '\u00a0€',
                currencySymbolPlacement: 's',
                roundingMethod: 'D' /* 'U' */,
                emptyInputBehavior: 'null',
                symbolWhenUnfocused: '',
                selectOnFocus: 'false',
                currencySymbol: '',
                negativePositiveSignPlacement: 'p',
                minimumValue: outputMinNum,
                maximumValue: outputMaxNum
              }"
            ></VueAutonumeric>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from "axios";
import VueAutonumeric from "../shared/VueAutonumeric";
import jsonHelper from "../../shared/jsonHelper";
import templateHelper from "../../shared/templateHelper";
import { mapActions, mapGetters } from "vuex";
import { Select, /*Input,*/ Option } from "element-ui";
import conversionService from "../../services/backend/conversionService";
import umService from "../../services/backend/umService";
export default {
  components: {
    VueAutonumeric,
    "el-select": Select,
    "el-option": Option
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    fixedDecimals: {
      type: Number,
      required: false,
      default: -1
    },
    autoDecimals: {
      type: Number,
      required: false,
      default: -1
    },
    showInput: {
      type: Number,
      required: false,
      default: -1
    },
    overrideInputClass: {
      type: String,
      required: false,
      default: undefined
    },
    showOutput1: {
      type: Number,
      required: false,
      default: -1
    },
    overrideOutput1Class: {
      type: String,
      required: false,
      default: undefined
    },
    showOutput2: {
      type: Number,
      required: false,
      default: -1
    },
    overrideOutput2Class: {
      type: String,
      required: false,
      default: undefined
    },
    showLabel: {
      type: Number,
      required: false,
      default: -1
    },
    showDropDown: {
      type: Number,
      required: false,
      default: -1
    },
    unidataEditorColumns: {
      type: String,
      required: false,
      default: "col-4"
    },
    validateUsrValue: {
      type: Boolean,
      required: false,
      default: false
    },
    correlatedFields: {
      type: Array,
      required: false,
      default: () => []
    },
    allowNull: {
      type: Boolean,
      required: false,
      default: true
    },
    minValue: {
      type: String,
      required: false,
      default: ""
    },
    maxValue: {
      type: String,
      required: false,
      default: ""
    },
    disabilita: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      unidatoObject: null,
      visible: true,
      inputVal: 0.0,
      inputValDef: 0.0,
      verifyValueOutput: 0,
      termicBalanceOutput: 0,
      selectedUM: null,
      referenceUM: null,
      dropdownUms: [],
      umDecimalNum: -1,
      roundingMethod: "D",
      ready: "loading"
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    cmpEmptyBehavior() {
      if (this.allowNull) {
        return "null";
      } else {
        if (this.inputValDef != null) {
          return this.inputValDef;
        } else {
          return "null";
        }
      }
    },
    templateConfiguration() {
      return this.getTemplateConfig();
    },
    order() {
      if (this.unidatoObject == null) return 9999;
      return this.unidatoObject.order;
    },
    inputDecimalNum() {
      if (this.fixedDecimals != -1) {
        return this.fixedDecimals;
      }
      if (this.umDecimalNum != -1) {
        return this.umDecimalNum;
      }
      return 8;
    },
    balanceDecimalNum() {
      if (this.fixedDecimals != -1) {
        return this.fixedDecimals;
      }
      if (this.autoDecimals != -1) {
        return this.getAutoDecimals(this.autoDecimals, this.termicBalanceOutput);
      }
      if (this.umDecimalNum != -1) {
        return this.umDecimalNum;
      }
      return 8;
    },
    outputDecimalNum() {
      if (this.fixedDecimals != -1) {
        return this.fixedDecimals;
      }
      if (this.autoDecimals != -1) {
        return this.getAutoDecimals(this.autoDecimals, this.verifyValueOutput);
      }
      if (this.umDecimalNum != -1) {
        return this.umDecimalNum;
      }
      return 8;
    },
    outputMinNum() {
      if (this.minValue != "") {
        return this.minValue;
      }
      return "-99999999";
    },
    outputMaxNum() {
      if (this.maxValue != "") {
        return this.maxValue;
      }
      return "99999999";
    }
  },
  watch: {
    projects: function() {
      var that = this;
      that.unidatoObject = jsonHelper.getProperty(that.projects, that.path);
      if (that.unidatoObject) {
        that.inputVal = that.unidatoObject.input.usrValue.value;
        that.referenceUM = that.unidatoObject.input.refValue.um;
        that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
        that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
        that.selectedUM = that.unidatoObject.input.usrValue.um;
      }
    }
  },
  destroyed: function() {
    this.unsubscribe();
  },
  mounted: function() {
    if (this.parentPath != undefined && this.parentPath != null && this.parentPath != "") {
      this.path = this.parentPath + this.name;
      this.unidatoObject = jsonHelper.getProperty(this.projects, this.path);
    }
    var that = this;

    // alert(that.path + " >> " + JSON.stringify(that.unidatoObject));

    if (that.unidatoObject) {
      if (that.unidatoObject.category) {
        umService.getUms(that.unidatoObject.category).then(function(data) {
          data.forEach(element => {
            that.dropdownUms.push({
              value: element.id,
              label: element.descrizione,
              decimals: element.decimals
            });
          });
          var um = that.unidatoObject.input.usrValue.um;
          if (um != undefined) that.setUM(um);
          that.ready = "";
          that.inputVal = that.unidatoObject.input.usrValue.value;
          that.inputValDef = that.inputVal;
          that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
          that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
          that.referenceUM = that.unidatoObject.input.refValue.um;
        });
      } else {
        that.ready = "";
        that.inputVal = that.unidatoObject.input.usrValue.value;
        that.inputValDef = that.inputVal;
        that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
        that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
      }
    }

    this.unsubscribe = this.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "_prjModule/CHANGE_PROPERTY") {
        if (mutation.payload.path.startsWith(that.path)) {
          that.unidatoObject = jsonHelper.getProperty(that.projects, that.path);
          if (that.unidatoObject) {
            that.inputVal = that.unidatoObject.input.usrValue.value;
            that.referenceUM = that.unidatoObject.input.refValue.um;
            that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
            that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
            that.selectedUM = that.unidatoObject.input.usrValue.um;
          }
        }
      }
    });
  },
  methods: {
    ...mapActions("_prjModule", ["changeProperty"]),
    onBlur: function() {
      var that = this;

      var unidato = jsonHelper.getProperty(that.projects, that.path);

      var bEseguiValidate = true;

      if (unidato.input.usrValue.value && that.inputVal) {
        if (
          unidato.input.usrValue.value.toFixed(that.inputDecimalNum) ==
          that.inputVal.toFixed(that.inputDecimalNum)
        ) {
          bEseguiValidate = false;
        }
      }

      if (bEseguiValidate) {
        unidato.input.usrValue.value = that.inputVal;
        unidato.input.usrValue.um = that.selectedUM;
        unidato.input.refValue.value = that.inputVal;
        unidato.input.refValue.um = that.selectedUM;
        that.changeProperty({
          path: that.path + ".input",
          value: unidato.input
        });

        if (that.validateUsrValue) {
          conversionService
            .validateUsrValue({
              unidato: unidato,
              project: that.GetSimplexProject(), //that.projects[prjName],
              path: that.name
            })
            .then(function(data) {
              that.changeProperty({
                path: that.path + ".input",
                value: data.input
              });
            });
        }
        if (that.correlatedFields) {
          if (that.correlatedFields.length > 0) {
            conversionService
              .correlateValues({
                unidato: unidato,
                project: that.GetSimplexProject(), //that.projects[prjName],
                path: that.name,
                correlatedFields: that.correlatedFields
              })
              .then(function(data) {
                if (data != null) {
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].unidato != null) {
                      that.changeProperty({
                        path: that.parentPath + data[i].name,
                        value: data[i].unidato
                      });
                    }
                  }
                }
              });
          }
        }
      }
    },
    setUM: function(newUM) {
      var that = this;
      this.selectedUM = newUM;
      this.dropdownUms.forEach(function(Um) {
        if (Um.value == that.selectedUM) {
          that.umDecimalNum = Um.decimals;
        }
      });
    },
    getTemplateConfig: function() {
      return templateHelper.getTemplateConfiguration(
        this.unidatoObject.behavior.templateConfiguration
      );
    },

    converti(byPassDispatch) {
      var that = this;
      that.dropdownUms.forEach(function(Um) {
        if (Um.value == that.selectedUM) {
          that.umDecimalNum = Um.decimals;
        }
      });

      if (!byPassDispatch) {
        that.changeProperty({
          path: that.path + ".input.usrValue.um",
          value: that.selectedUM
        });
        that.changeProperty({
          path: that.path + ".output.usrValue.um",
          value: that.selectedUM
        });
        that.changeProperty({
          path: that.path + ".outputBilancio.usrValue.um",
          value: that.selectedUM
        });
      }

      var unidato = jsonHelper.getProperty(that.projects, that.path);

      //var prjName = that.path.substring(0, that.path.indexOf("."));
      conversionService
        .convertUnidatoRefUsr({
          unidato: unidato,
          project: this.GetSimplexProject(), //that.projects[prjName],
          path: that.path
        })
        .then(function(data) {
          that.changeProperty({
            path: that.path + ".input.usrValue.value",
            value: data.input.usrValue.value
          });
          that.changeProperty({
            path: that.path + ".output.usrValue.value",
            value: data.output.usrValue.value
          });
          that.changeProperty({
            path: that.path + ".outputBilancio.usrValue.value",
            value: data.outputBilancio.usrValue.value
          });
        });
    },

    changeSelectedUM: function() {
      var that = this;
      var oldUm = jsonHelper.getProperty(that.projects, that.path + ".input.usrValue.um");

      if (that.selectedUM !== oldUm) {
        that.converti(false);
      }
    },

    getAutoDecimals: function(maxDec, value) {
      if (value < 10) {
        return Math.min(maxDec, 8);
      }
      if (value < 1000) {
        return Math.min(maxDec, 2);
      }
      return Math.min(maxDec, 0);
    },

    GetSimplexProject() {
      var prjName = this.path.substring(0, this.path.indexOf("."));
      var P = this.projects[prjName];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      deepClone_P.innerProject = null;
      deepClone_P.selectionOutput.selectionOutput = [];
      deepClone_P.results = [];
      return deepClone_P;
    }
  }
};
</script>

<style lang="scss">
$input-height: 30px;

.unidata-editor {
  background-color: transparent;
  margin: 0 0 0px 0px !important;
  //padding: 10px 0;
  width: 100%;
  outline: none;

  .unidata-item-container {
    border: none;
    height: $input-height !important;
    padding: 0 0px;

    .select {
      border: none;
    }

    .form-control {
      padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.auto-numeric {
        padding: 0 5px;
        text-align: center;
      }

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}
.label-unidato {
  margin-top: 9px;
  margin-bottom: 0px;
}

.loading {
  opacity: 0.3;
}
</style>
